import gql from 'graphql-tag'

export default gql`mutation go($id: Float!){
  removeProjectClientInvoice(id: $id){
    id
    project{
      project_id
      name
      clients{
        client_id
        name
      }
    }
    client{
      client_id
      name
    }
    issued_at
    paid_at
    created_at
    invoice_url
    breakdown{
      id
      description
      amount
    }
  }
}`